<template>
    <b-card title="">
        <h3 class="text-primary font-weight-bold mb-2">
            รหัสนายหน้า
        </h3>
        <b-row>
            <b-col md="6">
                <b-form-group label-for="lastname">
                    <h5 class="h4 font-weight-bold">รหัสนายหน้า</h5>
                    <b-form-input v-model="formUser.agentId" placeholder="รหัสนายหน้า" />
                </b-form-group>
            </b-col>
        </b-row>
        <hr>
        </hr>
        <h3 class="text-primary font-weight-bold mb-2">
            ข้อมูลนายจ้าง
        </h3>
        <b-row>
            <b-col md="6">
                <b-form-group label-for="employerNumber">
                    <h5 class="h4 font-weight-bold">เลขที่ประจำตัวประชาชน/ทะเบียนนิติบุคคล</h5>
                    <b-form-input v-model="formUser.employerNumber"
                        placeholder="เลขที่ประจำตัวประชาชน/ทะเบียนนิติบุคคล" />
                </b-form-group>
            </b-col>
            <b-col md="6"></b-col>
            <b-col md="6">
                <b-form-group label-for="employerName">
                    <h5 class="h4 font-weight-bold">ชื่อนายจ้าง</h5>
                    <b-form-input v-model="formUser.employerName" placeholder="ชื่อนายจ้าง" />
                </b-form-group>
            </b-col>
            <b-col md="6"></b-col>
            <b-col md="6">
                <b-form-group label-for="employerPhone">
                    <h5 class="h4 font-weight-bold">เบอร์โทรนายจ้าง</h5>
                    <b-form-input v-model="formUser.employerPhone" placeholder="เบอร์โทรนายจ้าง" />
                </b-form-group>
            </b-col>
            <b-col md="6"></b-col>
        </b-row>
        <hr>
        </hr>
        <h3 class="text-primary font-weight-bold mb-2">
            ข้อมูลแรงงานต่างด้าว
        </h3>
        <b-row>
            <b-col md="6">
                <div class="demo-inline-spacing">
                    <span class="h4 font-weight-bold">
                        ประเภท
                    </span>
                    <b-form-radio v-model="selected" name="some-radio9" value="MOU" class="custom-control-danger">
                        MOU
                    </b-form-radio>
                    <b-form-radio v-model="selected" name="some-radio9" value="NL" class="custom-control-warning">
                        NL
                    </b-form-radio>
                    <b-form-radio v-model="selected" name="some-radio9" value="IW" class="custom-control-info">
                        IW
                    </b-form-radio>
                </div>
                <br></br>
            </b-col>

            <b-col md="6">
                <br></br>
            </b-col>
            <b-col md="6">
                <b-form-group label-for="IdCodeInput">
                    <template #label>
                        <span class="h5 font-weight-bold">
                            AL Code
                            <span style="color: red;">(เลือกประเภท IW ไม่ต้องระบุ AL Code)</span>
                        </span>
                    </template>

                    <b-form-input ref="IdCodeInput" v-model="formUser.IdCode" :disabled="selected === 'IW'"
                        :class="{ 'is-invalid': showError }" placeholder="AL Code" />
                    <b-form-invalid-feedback v-if="showError">
                        กรุณากรอก AL Code
                    </b-form-invalid-feedback>
                </b-form-group>
                <!-- <b-form-group label-for="IdCodeInput">
                    <template #label>
                        <span class="h5 font-weight-bold">
                            AL Code
                            <span style="color: red;">***</span>
                        </span>
                    </template>

                    <b-form-input ref="IdCodeInput" v-model="formUser.IdCode" :class="{ 'is-invalid': showError }"
                        placeholder=" AL Code" />
                    <b-form-invalid-feedback v-if="showError">
                        กรุณากรอก AL Code
                    </b-form-invalid-feedback>
                </b-form-group> -->
            </b-col>
            <b-col md="6"></b-col>
            <b-col md="3">
                <b-form-group label-class="h4 font-weight-bold" label="คำนำหน้า" label-for="prefix">
                    <b-form-select v-model="formUser.prefix" id="prefix" :options="prefixOptions" />
                </b-form-group>
            </b-col>
            <b-col md="6"></b-col>
            <b-col md="6">
                <b-form-group label-class="h4 font-weight-bold" label="ชื่อ" label-for="firstname">
                    <b-form-input v-model="formUser.firstname" id="firstname" placeholder="ชื่อ" />
                </b-form-group>
            </b-col>
            <b-col md="6"></b-col>
            <b-col md="6">
                <b-form-group label-class="h4 font-weight-bold" label="นามสกุล" label-for="lastname">
                    <b-form-input v-model="formUser.lastname" id="lastname" placeholder="นามสกุล" />
                </b-form-group>
            </b-col>
            <b-col md="6"></b-col>
            <b-col md="3">
                <b-form-group label-class="h4 font-weight-bold" label="เพศ" label-for="gender">
                    <b-form-select v-model="formUser.gender" id="gender" :options="genderOptions" />
                </b-form-group>
            </b-col>
            <b-col md="8"></b-col>
            <b-col md="3">
                <b-form-group label-class="h4 font-weight-bold" label="สัญชาติ" label-for="nationality">
                    <b-form-select v-model="formUser.nationality" id="nationality" :options="nationalityOptions"
                        required />
                </b-form-group>
            </b-col>
            <b-col md="6">
            </b-col>
        </b-row>
        <hr>
        </hr>
        <b-col md="6">
            <h3 class="text-primary font-weight-bold mb-2">ข้อมูลศูนย์แรงงานต่างด้าว</h3>
        </b-col>
        <b-col md="6">
            <b-form-group>
                <h5 class="h4 font-weight-bold">เลือกศูนย์แรงงานต่างด้าว</h5>
                <b-form-select v-model="selectedBorder" :options="options" @change="GetChange" />
            </b-form-group>
        </b-col>
        <b-col md="6">
            <b-card-text class="h4 mt-1 mb-0 font-weight-bold mb-2" v-if="selectedBorder && count_data != 0">
                <template v-if="out_dateDefault">
                    <span class="text-primary">
                        คิวที่เหลือ:
                        <strong>
                            / {{ selectedBorder }} / {{ count_data }}
                        </strong>
                        คิว
                    </span>
                </template>
                <template v-else>
                    <span class="text-danger">กรุณาเลือกวันที่</span>
                </template>
            </b-card-text>
        </b-col>


        <b-col md="6">
            <b-form-group>
                <h5 class="h4 font-weight-bold">วันที</h5>
                <flat-pickr v-model="out_dateDefault" class="form-control" :config="outDateConfig" />
                <div class="invalid-feedback">วันที</div>
            </b-form-group>
        </b-col>
        <!-- <b-col md="6">
            <h5 class="h4 font-weight-bold">เลือกรอบ</h5>
            <div class="demo-inline-spacing border rounded p-1">
                <b-form-radio v-model="selected" name="some-radio9" value="รอบเช้า" class="h4 custom-control-primary">
                    รอบเช้า
                </b-form-radio>
                <b-form-radio v-model="selected" name="some-radio9" value="รอบบ่าย" class=" h4 custom-control-success">
                    รอบบ่าย
                </b-form-radio>
            </div>
        </b-col> -->
        <!-- 
        <b-col md="6">
            <br />
            <b-form-group>
                <h5 class="h4 font-weight-bold">วันที่เข้าประเทศไทย</h5>
                <flat-pickr v-model="in_dateDefault" class="form-control" :config="{ dateFormat: 'd-m-Y' }" />
                <div class="invalid-feedback">วันที่เข้าประเทศไทย</div>
            </b-form-group>
        </b-col> -->
        <br></br>
        <b-col cols="12">
            <b-button variant="success" type="submit" @click.prevent="validationForm" :disabled="isLoading">
                <template v-if="isLoading">
                    <b-spinner small type="grow" class="mr-1" />
                    กำลังบันทึก...
                </template>
                <template v-else>
                    บันทึกข้อมูล
                </template>
            </b-button>
        </b-col>

    </b-card>
</template>
<script>
import Ripple from "vue-ripple-directive";
import store from "@/store/index";
import API from "@/connect/config";
import axios from "axios";
import * as XLSX from "xlsx";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import { BSpinner, BButton } from 'bootstrap-vue'
import { togglePasswordVisibility } from "@core/mixins/ui/forms";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import QRCode from "qrcode";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

import flagSrcL from '@/assets/images/icons/1.png';
import flagSrcR from '@/assets/images/icons/2.png';
dayjs.extend(customParseFormat);
export default {
    components: {
        flatPickr,
        BButton,
        BSpinner,
    },
    directives: {
        Ripple,
    },
    mixins: [togglePasswordVisibility],

    data() {
        return {
            perPage: 100,
            pageOptions: [25, 50, 100],
            totalRows: 1,
            currentPage: 1,
            sortBy: "",
            sortDesc: false,
            sortDirection: "asc",
            filter: null,
            filterOn: [],
            fields: [
                { key: "select", label: "", sortable: false },
                { key: "No.", label: "ลำดับที่" },
                { key: "employerNumber", label: "เลขประจำตัวนายจ้าง" },
                { key: "IdCode", label: "เลขพาสปอร์ต/เลขที่ประจำตัว13หลัก" },
                { key: "Prefix", label: "คำนำหน้า" },
                { key: "firstname", label: "ชื่อ" },
                { key: "lastname", label: "นามสกุล" },
                { key: "gender", label: "เพศ" },
                { key: "DateofBirth", label: "วันเดือนปีเกิด" },
                // { key: "status", label: "วันเกิด" },
                // { key: "action", label: "Print" }, // ✅ เพิ่มตรงนี้
            ],
            items: [],
            showError: false,
            showErrorfile: false,
            formUser: {
                agentId: "",
                IdCode: "",
                firstname: "",
                lastname: "",
                email: "",
                phone: "",
                gender: '',
                nationality: '',
                IdCode: '',
                prefix: '',
                employerName: '',
                employerNumber: '',
                employerPhone: '',
                Issuerdate: '',
                Expireddate: '',
                Birthdate: '',

            },
            file: null,
            excelData: [],
            excelHeader: [],
            options: [{ value: '', text: "เลือกศูนย์" }],
            selectedBorder: 'เลือกศูนย์', // 👉 เซ็ต default ตรงนี้

            prefixOptions: [
                { value: '', text: '--- เลือกคำนำหน้า ---' },
                { value: 'MR.', text: 'MR.' },
                { value: 'MRS.', text: 'MRS' },
                { value: 'MISS', text: 'MISS' },
                { value: 'MS.', text: 'MS.' }, // ✅ เพิ่ม MS.
            ],
            genderOptions: [
                { value: '', text: '--- เลือกเพศ ---' },
                { value: 'M', text: 'Male' },
                { value: 'F', text: 'Female' },
            ],
            nationalityOptions: [
                { value: '', text: '--- เลือกสัญชาติ ---' },
                { value: 'LAOS', text: 'LAOS' },
                { value: 'CAMBODIA', text: 'CAMBODIA' },
                { value: 'MYANMAR', text: 'MYANMAR' },
            ],
            outDateConfig: {
                dateFormat: "d-m-Y",
                onChange: this.handleOutDateChange.bind(this),
            },
            DateConfig: {
                dateFormat: "Y-m-d", // format ที่ใช้ส่งจริง
                altInput: true,
                altFormat: "d-m-Y",  // format ที่แสดงผล
            },
            startDate: new Date(),
            endDate: new Date(),
            in_dateDefault: new Date(), // หรือใช้ null, หรือ new Date() ก็ได้
            out_dateDefault: new Date(), // หรือใช้ null, หรือ new Date() ก็ได้
            count_data: 0,
            showError: false,
            isLoading: false,
            selected: "MOU", // ✅ "รอบเช้า" ถูกเลือกโดยอัตโนมัติ
        };
    },
    computed: {
        allSelected() {
            return (
                this.items.length > 0 && this.items.every((item) => item._selected)
            );
        },
        isIndeterminate() {
            const total = this.items.length;
            const selected = this.items.filter((i) => i._selected).length;
            return selected > 0 && selected < total;
        },
        hasSelected() {
            return this.items.some((item) => item._selected);
        },
    },
    created() {
        const jwt = JSON.parse(localStorage.getItem("company_jwt"));
        console.log(jwt);
        //   this.outDateConfig.onChange = this.handleOutDateChange;
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0'); // เดือนเริ่มจาก 0
        const year = today.getFullYear();

        this.handleOutDateChange('', `${day}-${month}-${year}`);
        // this.getDataTable();
    },
    mounted() {
        this.getDataSelectOption();

        // Set the initial number of items
        this.totalRows = this.items.length;
    },
    methods: {
        async GetChange() {
            this.handleOutDateChange(this.out_dateDefault, this.formatToYYYYMMDD(this.out_dateDefault).replace(/(\d{4})(\d{2})(\d{2})/, '$3-$2-$1'));

        },
        async handleOutDateChange(selectedDates, dateStr) {

            console.log(dateStr);
            console.log(selectedDates);
            //  this.out_dateDefault = selectedDates; // อัปเดตค่า out_dateDefault ด้วย dateStr

            console.log("📅 วันที่ออก (Date object):", this.out_dateDefault); // Date object
            console.log("📅 วันที่ออกถูกเลือก:", dateStr.split("-"));
            console.log("ด่านชายแดน:", this.selectedBorder);
            // ถ้ามีวันที่เลือก ให้ set 500
            //if (selectedDates && selectedDates.length > 0) {
            if (this.selectedBorder == null) {
                console.log("Selected Border:", this.selectedBorder);
                return;
            }

            const [dayExit, monthExit, yearExit] = dateStr.split("-");
            try {
                const jwt = JSON.parse(localStorage.getItem("company_jwt"));
                const params = {
                    staffId: jwt.userId,
                    date: `${yearExit}${monthExit}${dayExit}`,
                };
                console.log("Request Params", params);
                const res = await axios.get(`${API}queueStatus`, {
                    params,
                    headers: {
                        Authorization: await store.dispatch("getAuthorization"),
                    },
                });
                console.log((res.data.message.centers));

                const stationData = res.data.message.centers.find(
                    (station) => station.centerName === this.selectedBorder
                );
                console.log("stationData:", stationData);

                if (stationData) {
                    this.count_data = stationData.remaining; // รีเซ็ตค่า count_data ก่อนคำนวณใหม่
                } else {
                    console.warn("ไม่พบสถานีที่ตรงกับ:", this.selectedBorder);
                    this.count_data = 0; // หรือค่า default อื่น ๆ
                }

                // console.log("API Response", stationData);
                return res.data.message.data;
            } catch (err) {
                console.error("❌ Error:", err.response?.data || err.message);
            } finally {
                this.isBusy = false;
            }
        },
        async getDataSelectOption() {
            const jwt = JSON.parse(localStorage.getItem("company_jwt"));
            try {
                const params = {
                    userId: jwt.userId,
                    configType: "center",
                };
                console.log("API Request Params", params);
                const res = await axios.get(`${API}config`, {
                    params,
                    headers: {
                        Authorization: await store.dispatch("getAuthorization"),
                    },
                });

                const responseData = res.data.message.data;
                // แปลงข้อมูลให้ตรงกับ dropdown
                const dynamicOptions = responseData.map((item) => ({
                    value: item.name,
                    text: item.name,
                }));
                console.log(dynamicOptions);
                this.options = [{ value: '', text: "เลือกศูนย์" }, ...dynamicOptions];
                // ตั้งค่า default เป็นตัวแรก    
                this.selectedBorder = this.options[0].value;
            } catch (err) {
                if (err.response) {
                    console.error("❌ API Error:", err.response.status);
                    console.error("Response:", err.response.data);
                } else {
                    console.error("❌ Error:", err.message);
                }
            }
        },
        validate() {
            if (!this.formUser.IdCode) {
                this.showError = true;

                // scroll ไปยัง input
                this.$nextTick(() => {
                    this.$refs.IdCodeInput.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    this.$refs.IdCodeInput.$el.focus();
                });

                return false;
            }

            this.showError = false;
            return true;
        },
        validatefile() {
            const valid = !!this.file;
            this.showErrorfile = !valid;

            return valid;
        },
        info(item, index, button) {
            this.infoModal.title = `Row index: ${index}`;
            this.infoModal.content = JSON.stringify(item, null, 2);
            this.$root.$emit("bv::show::modal", this.infoModal.id, button);
        },
        resetInfoModal() {
            this.infoModal.title = "";
            this.infoModal.content = "";
        },
        // onFiltered(filteredItems) {
        //   // Trigger pagination to update the number of buttons/pages due to filtering
        //   this.totalRows = filteredItems.length;
        //   this.currentPage = 1;
        // },

        onFiltered(filteredItems) {
            // Optional: handle filtered results
        },

        async Postentry(userId, IdCode, employerName, employerNumber, employerPhone) {
            const jwt = JSON.parse(localStorage.getItem("company_jwt"));

            const dateObj = this.out_dateDefault; // Date object
            const year = dateObj.getFullYear();
            const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // เดือนเริ่มจาก 0
            const day = String(dateObj.getDate()).padStart(2, '0');


            const dateObj_in = this.in_dateDefault; // Date object
            const year_in = dateObj_in.getFullYear();
            const month_in = String(dateObj.getMonth() + 1).padStart(2, '0'); // เดือนเริ่มจาก 0
            const day_in = String(dateObj.getDate()).padStart(2, '0');


            // const _status =
            //     [{"ลงทะเบียน":"สำเร็จ"}]

            const _data = {
                userId: userId,
                staffId: jwt.userId,
                shift: this.selected,
                IdCode: IdCode,
                registeredExitDate: `${year}${month}${day}`,
                registeredEntryDate: `${year_in}${month_in}${day_in}`,
                stationName: this.selectedBorder,
                employerName: employerName,
                employerNumber: employerNumber,
                employerPhone: employerPhone,
                agentId: this.formUser.agentId,
                //   processingStatus: JSON.stringify(_status)

            };
            console.log(_data)

            try {
                const res = await axios.post(`${API}entry`, _data, {
                    headers: {
                        Authorization: await store.dispatch("getAuthorization"),
                    }
                });
                console.log("✅ Entry success:", res.data.message);
            } catch (error) {
                console.error("❌ Entry error:", error.response);
            }
        },
        async Postentry_preRegister(userId, IdCode, employerName, employerNumber, employerPhone) {
            const jwt = JSON.parse(localStorage.getItem("company_jwt"));

            // console.log("วันที่ออก (Date object):", this.out_dateDefault); // Date object
            // console.log(this.formatToYYYYMMDD(this.out_dateDefault));           // 20251002


            const _status =
                [{ "ลงทะเบียน": "สำเร็จ" }]

            const _data = {
                userId: userId,
                staffId: jwt.userId,
                IdCode: IdCode,
                employerName: employerName,
                employerNumber: employerNumber,
                employerPhone: employerPhone,
                agentId: this.formUser.agentId,
                processingStatus: JSON.stringify(_status),
                centerName: this.selectedBorder,
                centerAt: this.formatToYYYYMMDD(this.out_dateDefault),
                //  statusadmin: jwt.//คนที่บันทึกข้อมูล,
            };
            console.log(_data)

            try {
                const res = await axios.post(`${API}preRegister`, _data, {
                    headers: {
                        Authorization: await store.dispatch("getAuthorization"),
                    }
                });
                console.log("✅ Entry success:", res.data.message);
            } catch (error) {
                console.error("❌ Entry error:", error.response.data.message);
                //console.error("❌ Entry error:", error.response);
            }
        },
        formatToYYYYMMDD(dateInput) {
            let parsedDate;

            // 1. ถ้า dateInput เป็น Date object หรือ ISO string
            if (dateInput instanceof Date || /\d{4}-\d{2}-\d{2}T/.test(dateInput)) {
                parsedDate = dayjs(dateInput);
            } else if (/^\d{2}-\d{2}-\d{4}$/.test(dateInput)) {
                // 2. ถ้าเป็น string รูปแบบ DD-MM-YYYY หรือ MM-DD-YYYY
                // เราจะพยายาม parse แบบ DD-MM-YYYY ก่อน
                parsedDate = dayjs(dateInput, "DD-MM-YYYY", true);
                if (!parsedDate.isValid()) {
                    parsedDate = dayjs(dateInput, "MM-DD-YYYY", true);
                }
            } else {
                // กรณีอื่น ๆ
                parsedDate = dayjs(dateInput);
            }

            if (!parsedDate.isValid()) {
                console.error("วันที่ไม่ถูกต้อง:", dateInput);
                return null;
            }

            return parsedDate.format("YYYYMMDD");
        },
        async validationForm() {

            let typeValue = ""
            let IdCode = ""
            if (this.selected === "MOU") typeValue = '1'
            if (this.selected === "NL") typeValue = '2'
            if (this.selected === "IW") typeValue = ""

            console.log("ค่าที่ได้:", typeValue)
            console.log("ประเภทที่เลือก:", this.selected)

            if (this.selected === "IW") {
                // กรณี IW → append แค่ IdCode อย่างเดียว
                // IdCode = this.formUser.IdCode;
            } else {
                // กรณีอื่น → append typeValue + IdCode
                IdCode = typeValue + this.formUser.IdCode;

                if (!this.validate()) return;

            }

            this.isLoading = true;
            const jwt = JSON.parse(localStorage.getItem("company_jwt"));
            try {
                // const promises = this.items.map(async (item) => {
                const _data = new FormData();
                _data.append("companyId", jwt.companyId);
                _data.append("username", IdCode);
                _data.append("password", "Password@1");
                _data.append("role", "user");
                _data.append("prefix", this.formUser.prefix);
                _data.append("firstname", this.formUser.firstname);
                _data.append("lastname", this.formUser.lastname);
                _data.append("gender", this.formUser.gender);
                _data.append("nationality", this.formUser.nationality);
                _data.append("workAuthStatus", this.selected);
                //   _data.append("IdCode", this.formUser.IdCode);

                try {
                    const res = await axios.post(`${API}registerUser`, _data, {
                        headers: {
                            Authorization: await store.dispatch("getAuthorization"),
                        }
                    });
                    const res_userId = res.data.message.userId;
                    console.log("✅ response:", res.data.message);
                    // กรณี IW ใช้ IdCode ตรง ๆ
                    if (this.selected === "IW") {
                        IdCode = res.data.message.IdCode; // กรณี IW ใช้ IdCode จาก response ตรง ๆ
                    }
                    await this.Postentry_preRegister(res_userId, IdCode, this.formUser.employerName, this.formUser.employerNumber, this.formUser.employerPhone);

                    // await this.Postentry(res_userId, this.formUser.IdCode, this.formUser.employerName, this.formUser.employerNumber, this.formUser.employerPhone);
                    await this.createImageAndSave(IdCode)
                } catch (error) {
                    console.error("❌ Registration error:", error.response);
                    //    แสดงข้อความผิดพลาดใน Toast
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: error.response?.data?.message || "เกิดข้อผิดพลาด",
                            icon: "EditIcon",
                            variant: "danger",
                        },
                    });
                }
                //  });


                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: "บันทึกข้อมูลสำเร็จทั้งหมด",
                        icon: "CheckIcon",
                        variant: "success",
                    },
                });
            } catch (e) {
                console.log(e);
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: "เกิดข้อผิดพลาด",
                        icon: "EditIcon",
                        variant: "danger",
                    },
                });
                console.error("❌ เกิดข้อผิดพลาดใหญ่", e);
            } finally {
                this.isLoading = false;
            }
        },
        async createImageAndSave(IdCode) {

            // ==== ขนาดก่อน scale ====
            const W = 342;
            const H = 216;

            const canvas = document.createElement("canvas");
            canvas.width = W * 2;        // 2x resolution
            canvas.height = H * 2;

            const ctx = canvas.getContext("2d");
            ctx.scale(2, 2);             // ทุกสิ่งที่วาดใช้ W,H ตามจริง

            // ==== พื้นหลัง ====
            ctx.fillStyle = "#e6ffe4";
            ctx.fillRect(0, 0, W, H);

            // ==== Header ====
            const headerHeight = 40;
            ctx.fillStyle = "rgb(255,132,132)";
            ctx.fillRect(0, 0, W, headerHeight);

            // ---- ข้อความ header ----
            const headerText = "Myanmar Labor Registration Card";
            ctx.font = "bold 14px Arial";
            const textWidth = ctx.measureText(headerText).width;

            const centerX = W / 2;
            const centerY = headerHeight / 2;

            // โหลดธง
            const flagLeft = new Image();
            const flagRight = new Image();
            flagLeft.src = flagSrcL;
            flagRight.src = flagSrcR;

            await Promise.all([
                new Promise(r => flagLeft.onload = r),
                new Promise(r => flagRight.onload = r)
            ]);

            const flagWidth = 50;
            const flagHeight = 30;

            // ชิดขอบจริง
            const paddingFlag = 0;

            const leftFlagX = paddingFlag;
            const rightFlagX = W - flagWidth - paddingFlag;

            const flagY = centerY - flagHeight / 2;

            // วาดธง
            ctx.drawImage(flagLeft, leftFlagX, flagY, flagWidth, flagHeight);
            ctx.drawImage(flagRight, rightFlagX, flagY, flagWidth, flagHeight);

            ctx.fillStyle = "#000";
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillText(headerText, centerX, centerY);

            // ==== เนื้อหา ====
            ctx.fillStyle = "#000";
            ctx.font = "14px Arial";
            ctx.textAlign = "left";
            ctx.textBaseline = "top";

            const normalFont = "14px Arial";
            const boldFont = "bold 14px Arial";
            const marginLeft = 15;
            let startY = 70;
            const lineHeight = 20;

            // functions helper...
            function drawLabelValue(label, value) {
                ctx.font = normalFont;
                ctx.fillText(label, marginLeft, startY);
                const w = ctx.measureText(label).width;
                ctx.font = boldFont;
                ctx.fillText(value, marginLeft + w, startY);
                startY += lineHeight;
            }

            drawLabelValue("ID number  ", `${IdCode}`);
            drawLabelValue("Name surname  ", `${this.formUser.prefix} ${this.formUser.firstname} ${this.formUser.lastname}`);
            drawLabelValue("Nationality  ", `${this.formUser.nationality}`);

            const genderText = this.formUser.gender === "M" ? "Male" : this.formUser.gender === "F" ? "Female" : this.formUser.gender;
            drawLabelValue("Sex  ", genderText);

            drawLabelValue("Birth date  ", `${this.formUser.Birthdate}`);
            drawLabelValue("Issuer date  ", `${this.formUser.Issuerdate}`);
            drawLabelValue("Expired date  ", `${this.formUser.Expireddate}`);

            // ==== QR Hi-Res Generator ====
            function getHighResQr(url, scale = 6) {
                return new Promise((resolve, reject) => {
                    QRCode.toDataURL(url, {
                        scale: scale,
                        margin: 1,
                        errorCorrectionLevel: "H",
                    }, (err, dataUrl) => {
                        if (err) return reject(err);
                        const img = new Image();
                        img.onload = () => resolve(img);
                        img.onerror = reject;
                        img.src = dataUrl;
                    });
                });
            }

            try {
                // --- สร้าง URL ---
                const today = new Date();
                const d = String(today.getDate()).padStart(2, "0");
                const m = String(today.getMonth() + 1).padStart(2, "0");
                const y = today.getFullYear();

                const { VUE_APP_FONTEND_URL } = process.env;
                const qrUrl = `${VUE_APP_FONTEND_URL}booking?prm1=${IdCode}&prm2=${y + m + d}`;

                // --- โหลด QR ความละเอียดสูง ---
                const qrHigh = await getHighResQr(qrUrl, 8); // scale 8 คมมากที่สุด (ลอง 6–10)

                // ==== ตำแหน่ง QR (ใช้ W,H ไม่ใช่ canvas.width) ====
                const qrSize = 60;       // ขนาดแสดงจริง
                const padding = 15;      // ระยะห่างขอบ

                const qrX = W - qrSize - padding;
                const qrY = H - qrSize - padding;

                ctx.drawImage(qrHigh, qrX, qrY, qrSize, qrSize);

                // ดาวน์โหลดไฟล์
                const link = document.createElement("a");
                link.href = canvas.toDataURL("image/png", 0.92);
                link.download = `QR_${IdCode}.png`;
                link.click();

            } catch (err) {
                console.error("QR Error:", err);
            }
        }
        ,
        async resetForm() {
            this.formUser = {
                prefix: '',
                firstname: '',
                lastname: '',
                gender: '',
                nationality: '',
                IdCode: '',
                employerName: '',
                employerNumber: '',
                employerPhone: ''
            };

        },
    },
};
</script>